import { useQuery } from "@tanstack/react-query";
import api from "apis";
import { GetAutocompleteSuggestionsParams } from "apis/data-contracts";
import useDebouncedState from "features/common/hooks/useDebouncedState";

const useMyDeskAutoCompleteQuery = (
  options: GetAutocompleteSuggestionsParams,
) => {
  const option = useDebouncedState(options, 500);

  return useQuery({
    queryKey: api.document.getAutocompleteSuggestionsKey(option),
    queryFn: () => api.document.getAutocompleteSuggestions(option),
    enabled:
      option?.searchTerm !== undefined && option?.searchTerm.trim() !== "",
    placeholderData: (pre) => pre,
  });
};

export default useMyDeskAutoCompleteQuery;
